import $ from 'jquery';

import * as net from 'util/Net';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function patchJSONString({url, data}: {url: string; data: string}): Promise<any> {
  return Promise.resolve(
    $.ajax({
      contentType: 'application/json',
      type: 'PATCH',
      url,
      data,
      dataType: 'json',
      headers: net.getPOSTHeaders(),
    })
  );
}
